<template>
  <div :class="{form__row: row}">
    <ValidationProvider ref="provider"
                        tag="div"
                        class="form__checkbox"
                        :rules="rules"
                        v-slot="{errors}">
      <input
          type="checkbox"
          :id="id"
          :checked="value"
          name=""
          @change="handleInput"
      />
      <label :for="id">
        <slot v-if="label == null"></slot>
        {{ label }}
      </label>
      <span class="error" v-if="rules != null">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: 'checkbox',
  props: {
    row: {
      type: Boolean,
      default: false
    },
    label: String,
    id: {
      type: String,
      required: true
    },
    value: {
      type: Boolean
    },
    rules: String
  },
  methods: {
    handleInput () {
      this.$refs.provider.syncValue(!this.value)
      this.$refs.provider.validate()
      this.$emit('input', !this.value)
    }
  },
  mounted () {
    this.$refs.provider.syncValue(false)
  }
}
</script>

<style scoped>

</style>
